import React from "react";
import AreaChart from "../../../components/charts/areaChart/areaChart";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import PeriodType from "./PeriodType";

export const detectInterval = (data) => {
  let interval = "preserveEnd";

  data.map((item) => {
    if (item.name.indexOf(" - ") > -1) {
      interval = "preserveStartEnd";
    } else {
      interval = Math.floor(data.length * 0.08);
    }
  });

  return interval;
};

const YearOverYear = () => {
  const chartData = useSelector((state) => state.checkIns.graphData);
  const yearOverYearLoading = useSelector((state) => state.checkIns.yearOverYearLoading);

  const yearOverYearSettings = {
    chartData,
    interval: detectInterval(chartData),
    right: 80,
    left: 80,
    width: 1350,
    currencySymbol: "",
    hasRawData: true,
    showDecimals: true,
    hideLegend: true,
    tooltipName: "Check-In",
    margin: { top: 5, right: 60, left: 5, bottom: 5 },
    cartesianGridVerticalPoints: (width) => [width - 60] // To place the vertical line at the right we need the width minus margin-right
  };

  return (
    <>
      <div className="chart-header">
        <h2>Total Check-In Breakdown</h2>
        <div className="select-box" style={{ width: "200px" }}>
          {yearOverYearLoading ? (
            <button className="picky__input">
              <LoadingAnimation uiLoader />{" "}
            </button>
          ) : (
            <PeriodType />
          )}
        </div>
      </div>
      <AreaChart {...yearOverYearSettings} />
    </>
  );
};

export default YearOverYear;
